import Reflux from 'reflux'

export default Reflux.createActions([
	'reload',
	'showModal',
	'hideModal'
])



// WEBPACK FOOTER //
// ./src/actions/ingredientsTypes.js